import { localStorageContext } from '@hooks/useLocalStorage';

export const SearchLanguages = ['No', 'En', 'Da'] as const;
export type SearchLanguage = (typeof SearchLanguages)[number];

export const LowerCaseSearchLanguages = ['no', 'en', 'da'] as const;
export type LowerCaseSearchLanguage = (typeof LowerCaseSearchLanguages)[number];

export const Countries = ['no', 'dk'] as const;
export type Country = (typeof Countries)[number];

export const UpperCaseCountries = ['NO', 'DK'] as const;
export type UpperCaseCountry = (typeof Countries)[number];

export const getFlag = (country: Country | LowerCaseSearchLanguage | SearchLanguage) => {
  switch (country.toLowerCase()) {
    case 'da':
    case 'dk':
      return 'DK';
    case 'en':
      return 'US';
    case 'no':
      return 'NO';
    default:
      return '';
  }
};

export const defaultSearchLanguage: SearchLanguage = 'No';

export const defaultSearchCountry: Country = 'no';

const getLocalizationValue = <T>(
  context: keyof typeof localStorageContext,
  validOptions: readonly T[],
  defaultValue: T
): T => {
  const val = window.localStorage.getItem(localStorageContext[context]);
  if (!val) return defaultValue;
  const init = JSON.parse(val) as T;
  return validOptions.includes(init) ? init : defaultValue;
};

export const getCurrentSearchCountry = () =>
  getLocalizationValue('country', Countries, defaultSearchCountry);

export const getCurrentSearchLang = () =>
  getLocalizationValue('searchLanguage', SearchLanguages, defaultSearchLanguage);
